import { Checkbox, Typography } from 'antd';
import { useSelector } from 'react-redux';
import { FunctionComponent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import ConfirmModalComponent from 'components/confirmModal/confirmModal.component';
import NotificationService from 'core/services/notification';

import { onActivate } from 'modules/main/dashboard/services/dashboardService';
import { RootState } from 'stores/store';

interface AccountActivationModalProps {
	onActivateFinish: () => void;
    onClose: () => void;
	open: boolean;
}

const AccountActivationModal: FunctionComponent<AccountActivationModalProps> = ({ onActivateFinish, onClose, open }) => {
	const { t } = useTranslation();

	const company = useSelector((state: RootState) => state.company);

	const [startNow, setStartNow] = useState<boolean>(false);
	const [isActivating, setIsActivating] = useState<boolean>(false);

	const onActivateHandler = async () => {
		try {
			setIsActivating(true);
			await onActivate(startNow);
			onActivateFinish();
		} catch (error) {
			NotificationService.error(t('COMMON.ERROR'), t('COMMON.SUBMIT_ERROR'));
		}
	};

	return (
		<ConfirmModalComponent
			open={open}
			title={t('DASHBOARD.ACTIVATE_MODAL_TITLE')}
			subTitle={t('DASHBOARD.ACTIVATE_MODAL_SUBTITLE')}
			confirmText={t('COMMON.ACTIVATE')}
			onConfirm={onActivateHandler}
			onDiscard={onClose}
			isLoading={isActivating}>
			<div className="containerDiv">
				<Typography.Text>{t('DASHBOARD.START_DATE')}</Typography.Text>
				<div
					style={{
						padding: '7px 11px',
						background: '#f9fafb',
						border: '1px solid #d9d9d9',
						borderRadius: 6,
						fontSize: 16,
					}}>
					{company?.latest_subscription?.start_date}
				</div>
			</div>

			<Checkbox className="mt-3" onChange={(e) => setStartNow(e.target.checked)}>
				{t('DASHBOARD.START_NOW')}
			</Checkbox>
		</ConfirmModalComponent>
	);
};

export default AccountActivationModal;
